import React, { useEffect, useState } from 'react';

import { ChromePicker } from 'react-color';
import $ from "jquery";

function ColorPicker(props) {
    const id = props.id;
    const [background, setBackground] = useState(props.color);
    const [color, setColor] = useState(null);

    useEffect(() => {
        setColor(contrastingColor());
    }, [props]);

    function rgba2hex(color) {
        var a,
            rgb = color.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i),
            alpha = ((rgb && rgb[4]) || "").trim(),
            hex = rgb ?
                (rgb[1] | 1 << 8).toString(16).slice(1) +
                (rgb[2] | 1 << 8).toString(16).slice(1) +
                (rgb[3] | 1 << 8).toString(16).slice(1) : color;
        if (alpha !== "") {
            a = alpha;
        } else {
            a = 1;
        }

        a = Math.round(a * 100) / 100;
        alpha = Math.round(a * 255);
        var hexAlpha = (alpha + 0x10000).toString(16).substr(-2).toUpperCase();
        hex = hex + hexAlpha.toLowerCase();

        return hex;
    }

    function handleChangeComplete(color) {
        setBackground("#" + rgba2hex(`rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`));
    };

    function onClickColor(e) {
        if ($(e.target).next().hasClass("dis-none")) {
            $(".option-card-settings .chrome-picker").addClass("dis-none");
            $(e.target).next().removeClass("dis-none");
            $(`.option-card-settings .bg-click.${id}`).css({ display: "block" });
        } else {
            $(".option-card-settings .chrome-picker").addClass("dis-none");
            $(".option-card-settings .bg-click").css({ display: "none" });
        }
    }

    function hideColorPicker() {
        $(".option-card-settings .chrome-picker").addClass("dis-none");
        $(".option-card-settings .bg-click").css({ display: "none" });

        setColor(contrastingColor());
        props.onChange(id, background);
    }

    function contrastingColor() {
        let color = background.substring(1);
        if (color.length === 8) {
            if (color[color.length - 2] <= 8) {
                return "#000000";
            }
            color = color.substring(0, color.length - 2);
        }
        return (`#${(luma(color) >= 165) ? '000' : 'fff'}`);
    }

    function luma(color) {
        var rgb = (typeof color === 'string') ? hexToRGBArray(color) : color;
        return (0.2126 * rgb[0]) + (0.7152 * rgb[1]) + (0.0722 * rgb[2]);
    }

    function hexToRGBArray(color) {
        if (color.length === 3)
            color = color.charAt(0) + color.charAt(0) + color.charAt(1) + color.charAt(1) + color.charAt(2) + color.charAt(2);
        else if (color.length !== 6)
            throw ('Invalid hex color: ' + color);
        var rgb = [];
        for (var i = 0; i <= 2; i++)
            rgb[i] = parseInt(color.substr(i * 2, 2), 16);
        return rgb;
    }

    return (
        <>
            <div onClick={hideColorPicker} className={"bg-click " + props.id}></div>
            <p style={{ margin: "0" }}>{props.desc}</p>
            <p onClick={onClickColor} className="color-text" style={{ backgroundColor: background, color: color }}>hex: {background}</p>
            <ChromePicker
                id={props.id}
                className="dis-none"
                disableAlpha={false}
                color={background}
                onChange={handleChangeComplete}
            />
        </>
    );
}

export default ColorPicker;